var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.componentClass }, [
    _c("p", [_vm._v(_vm._s(_vm.widgetInfo.widgetDescription))]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters mt-4 text-center" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-6 col-lg-8" },
        [
          _c("b-form-file", {
            ref: "uploadUserList",
            staticClass: "mt-3",
            attrs: { plain: "" },
            on: { change: _vm.onFileChange },
            model: {
              value: _vm.userFile,
              callback: function($$v) {
                _vm.userFile = $$v
              },
              expression: "userFile"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mt-3 smaller-font-content text-left" }, [
      _vm._v(_vm._s(_vm.widgetInfo.widgetDescriptionFooter))
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-warning text-left smaller-font-content py-2",
        attrs: { role: "alert" }
      },
      [
        _c("div", { staticClass: "row no-gutters w-100" }, [
          _c(
            "div",
            { staticClass: "d-inline-block my-auto mr-2 align-middle" },
            [_c("i", { staticClass: "fas fa-exclamation-circle" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-inline-block col" }, [
            _vm._v("It is required that an agent's "),
            _c("strong", [_vm._v("First Name")]),
            _vm._v(", "),
            _c("strong", [_vm._v("Middle Initial")]),
            _vm._v(" and "),
            _c("strong", [_vm._v("Last Name")]),
            _vm._v(" match the agent's "),
            _c("strong", [_vm._v("Agent of Record")]),
            _vm._v(
              " in Progressive's system. This is required for agents to bind Progressive policies within the QuinStreet Rating Platform."
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3599d980", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3599d980","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/UploadusersBlock.vue
// module id = null
// module chunks = 